import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { EnvironmentService } from '../services';

@Directive({
  selector: '[data-test]',
  standalone: false,
})
export class DataTestDirective implements OnInit {
  @Input('data-test') dataTest: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit(): void {
    if (this.environmentService.env === 'prod') {
      this.renderer.removeAttribute(this.el.nativeElement, 'data-test');
    } else {
      this.renderer.setAttribute(this.el.nativeElement, 'data-test', this.dataTest);
    }
  }
}
